@if (formJson) {
  <div>
    <ptl-form-as-json [formJson]="formJson"></ptl-form-as-json>
  </div>
}